import {AfterViewInit, Component, forwardRef, Input, QueryList, ViewChildren} from "@angular/core";
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {ChosenCategoryService} from "../../../../../../../../common/components/business-category/chosen-category.service";
import {isNullOrUndefined} from "util";
import {CheckboxComponent} from "../../../../../../../../common/components/category-checkbox";
import {StringUtils} from "../../../../../../../../common/utils";

const CUSTOM_BUSINESS_CATEGORY_LIST_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SelectableListComponent),
    multi: true
};

@Component({
    selector: 'tfl-selectable-list',
    template: `
        <ng-container *ngFor="let item of data">
            <tfl-material-card
                [id]="item.id"
                [title]="stringWithStrongTags(item,'code') + ' ' + stringWithStrongTags(item,'name')"
                [subtitle]="stringWithStrongTags(item,'path')"
            >
                <tfl-checkbox (itemDeSelected)="itemDeSelected($event)"
                              (itemSelected)="itemSelected($event)"
                              [item]="item"
                ></tfl-checkbox>
            </tfl-material-card>
        </ng-container>
    `,
    providers: [CUSTOM_BUSINESS_CATEGORY_LIST_CONTROL_VALUE_ACCESSOR]
})
export class SelectableListComponent implements AfterViewInit, ControlValueAccessor {

    @Input('data') private data: any[];

    @ViewChildren(CheckboxComponent) checkBoxes: QueryList<CheckboxComponent>;

    onChanged = () => {
    };
    onTouched = () => {
    };

    private loadedCategories = [];

    constructor(private categoryChoosedService: ChosenCategoryService) {
        this.categoryChoosedService.categoriesLoadedEvent.subscribe(categories => {
            this.loadedCategories = categories;
        });
    }

    private stringWithStrongTags(item, name) :string {
      return StringUtils.getStringToSetStrongTag(item,name);
    }

    ngAfterViewInit(): void {
        this.markLoadedCategories();
        this.subscribeToFeatureCheckBoxCountChangesAndMarkLoadedCategories();
        this.categoryChoosedService.categoryDeletedEvent.subscribe(category => {
            this.changeCheckBoxStateToByCategory(category, false);
        });
    }

    itemDeSelected(event) {
        this.categoryChoosedService.unSelected(event);
    }

    itemSelected(event) {
        this.categoryChoosedService.selected(event);
    }

    private changeCheckBoxStateToByCategory(category, state) {
        this.checkBoxes.forEach(checkbox => {
            if (category.id == checkbox.item.id) {
                checkbox.checked = state;
            }
        })
    }

    private markLoadedCategories() {
        this.loadedCategories.map(category => {
            this.changeCheckBoxStateToByCategory(category, true);
        });
    }

    private subscribeToFeatureCheckBoxCountChangesAndMarkLoadedCategories() {
        this.checkBoxes.changes.subscribe(() => {
            this.loadedCategories.map(category => {
                this.changeCheckBoxStateToByCategory(category, true);
            });
        });
    }

    registerOnChange(fn: any): void {
        this.onChanged = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    writeValue(obj: any): void {
        if (!isNullOrUndefined(obj)) {
            this.data = obj;
        }
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/business-categories/list/selectable-list.component.ts